import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/CommissionVendeur/';

export async function getAllForDevisCommandeFactureAsync(params) {
  const serverTableInput = generalTransformer(params);
  const response = await HTTP.post(URL_BASE + 'PGetAllForDevisCommandeFactureAsync', serverTableInput);
  return response;
}
export async function PGetAllForReglesAchatsAsync(ids) {
  const response = await HTTP.post(URL_BASE + 'PGetAllForReglesAchatsAsync', ids);
  return response;
}

export async function UpdateDateCommissionAsync(dateAndCommissions) {
  const response = await HTTP.put(URL_BASE + 'UpdateDateCommissionAsync', dateAndCommissions);
  return response;
}
